export default __webpack_public_path__ + "maps-examples-multiple-shapes-960-cf34d6b0e83d017fa47c4a72722bff4d.png";